import { Component, Input } from '@angular/core';
import { LoanPostStatusResponse } from '../../new-loans.service';
import { SimpleGlobalModalService } from 'libs/desktop/data-access/core-services/src/lib/GlobalModal/simple-global-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-loan-dashboard-contact-details',
    templateUrl: './loan-dashboard-contact-details.component.html',
    styleUrls: ['./loan-dashboard-contact-details.component.scss'],
    standalone: false
})
export class LoanDashboardContactDetailsComponent {
  @Input() loan: LoanPostStatusResponse;

  constructor(private _modalService: SimpleGlobalModalService, private _translateService: TranslateService) {}

  onPartnerLinkClick(partnerLink: string, partnerName: string): void {
    this._modalService.createModal({
      title: 'LOAN_REDIRECT_TO_PARTNER_TITLE',
      contentKey: 'LOAN_REDIRECT_TO_PARTNER_DESC',
      displayCloseButton: true,
      eventName: 'loan_partner_redirect',
      isError: false,
      size: 'medium',
      ctaKey: this._translateService.instant('LOAN_PARTNER_PRIMARY_CTA', { partnerName }),
      ctaAction: () => {
        window.open(partnerLink, '_blank');
      },
    });
  }
}
